/// <amd-module name="typeahead/features/UitkDropDownGeometryReplicatorForMercury" />

/// <amd-dependency path="jquery" name="$"/>

/// <reference path="../../typings/thirdparty/jquery/jquery.d.ts" />

import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import {IDropDownShowHandler} from "typeahead/core/presentation/IDropDownShowHandler";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";

const configuration: IStripingConfiguration[] = [
    {
        experiment: {
            id: 25633,
            name: "ess_non_mobile_typeahead_takeover_experience_flights",
        },
        tabs: ["flight"],
    },
    {
        experiment: {
            id: 25632,
            name: "ess_non_mobile_typeahead_takeover_experience_hotel",
        },
        tabs: ["hotel"],
    },
    {
        experiment: {
            id: 25635,
            name: "ess_non_mobile_typeahead_takeover_experience_packages",
        },
        tabs: ["package", "packageFlightHotel", "packageFlightHotelCar",
            "packageFlightCar", "packageHotelCar", "flightHotel", "flightHotelCar", "flightCar",
            "hotelCar", "carHotel", "carHotelFlight", "carFlight"],
    },
    {
        experiment: {
            id: 25634,
            name: "ess non mobile typeahead takeover experience cars",
        },
        tabs: ["car"],
    },
];

export class UitkDropDownGeometryReplicatorForMercury implements IDropDownShowHandler {
    private static applicableClients: string[] = [
        "Homepage",
        "AWSHomepage",
        "LXLandingPage",
        "CarsLandingPage",
        "FlightsLandingPage",
        "HotelsLandingPage",
        "PackageLandingPage",
        "RailsLandingPage"];

    private static readonly leftOffsetApplicableInputs: string[] = [
        "flight-origin-hp-flight",
        "flight-2-origin-hp-flight",
        "flight-3-origin-hp-flight",
        "flight-4-origin-hp-flight",
        "flight-5-origin-hp-flight",
        "hotel-destination-hp-hotel",
        "package-origin-hp-package",
        "package-origin-FC-hp-package",
        "hotel-destination-hp-package",
        "car-pickup-hp-car",
        "flight-origin-flp",
        "flight-2-origin-flp",
        "flight-3-origin-flp",
        "flight-4-origin-flp",
        "flight-5-origin-flp",
        "package-origin-flp-fh",
        "package-origin-flp-fhc",
        "package-origin-FC-flp-fc",
        "hotel-destination-hlp",
        "hotel-destination-hlp-hc",
        "package-origin-hlp-fh",
        "package-origin-hlp-fhc",
        "package-origin-plp-fh",
        "package-origin-plp-fhc",
        "package-origin-FC-plp-fc",
        "hotel-destination-plp-hc",
        "car-pickup-clp",
        "hotel-destination-clp-hc",
        "package-origin-clp-fhc",
        "package-origin-FC-clp-fc",
    ];

    private static readonly rightOffsetApplicableInputs: string[] = [
        "flight-destination-hp-flight",
        "flight-2-destination-hp-flight",
        "flight-3-destination-hp-flight",
        "flight-4-destination-hp-flight",
        "flight-5-destination-hp-flight",
        "package-destination-hp-package",
        "package-destination-FC-hp-package",
        "car-dropoff-hp-car",
        "flight-destination-flp",
        "flight-2-destination-flp",
        "flight-3-destination-flp",
        "flight-4-destination-flp",
        "flight-5-destination-flp",
        "package-destination-flp-fh",
        "package-destination-flp-fhc",
        "package-destination-FC-flp-fc",
        "package-destination-hlp-fh",
        "package-destination-hlp-fhc",
        "package-destination-plp-fh",
        "package-destination-plp-fhc",
        "package-destination-FC-plp-fc",
        "car-dropoff-clp",
        "package-destination-clp-fhc",
        "package-destination-FC-clp-fc",
    ];

    private static readonly twoInputsApplicable: string[] = [
        "flight-origin-hp-flight",
        "flight-2-origin-hp-flight",
        "flight-3-origin-hp-flight",
        "flight-4-origin-hp-flight",
        "flight-5-origin-hp-flight",
        "flight-destination-hp-flight",
        "flight-2-destination-hp-flight",
        "flight-3-destination-hp-flight",
        "flight-4-destination-hp-flight",
        "flight-5-destination-hp-flight",
        "package-origin-hp-package",
        "package-destination-hp-package",
        "package-origin-FC-hp-package",
        "package-destination-FC-hp-package",
        "car-pickup-hp-car",
        "car-dropoff-hp-car",
        "flight-origin-flp",
        "flight-2-origin-flp",
        "flight-3-origin-flp",
        "flight-4-origin-flp",
        "flight-5-origin-flp",
        "flight-destination-flp",
        "flight-2-destination-flp",
        "flight-3-destination-flp",
        "flight-4-destination-flp",
        "flight-5-destination-flp",
        "package-origin-flp-fh",
        "package-destination-flp-fh",
        "package-origin-flp-fhc",
        "package-destination-flp-fhc",
        "package-origin-FC-flp-fc",
        "package-destination-FC-flp-fc",
        "package-origin-hlp-fh",
        "package-destination-hlp-fh",
        "package-origin-hlp-fhc",
        "package-destination-hlp-fhc",
        "package-origin-plp-fh",
        "package-origin-plp-fhc",
        "package-origin-FC-plp-fc",
        "package-destination-plp-fh",
        "package-destination-plp-fhc",
        "package-destination-FC-plp-fc",
        "car-pickup-clp",
        "car-dropoff-clp",
        "package-origin-clp-fhc",
        "package-destination-clp-fhc",
        "package-origin-FC-clp-fc",
        "package-destination-FC-clp-fc",
    ];

    // @baseSpacingHorz as defined in uitoolkit; see uitoolkit/.../mixins.less (http://go/iuo39gal)
    private static baseSpacingHorz: number = 12;
    private static uitkTypeaheadWidthPx = 600;
    private static uitkTypeaheadMinWidthPx = 282;
    private static resizeEventTypes: string = "orientationchange resize";

    private static optimizeDropDownGeometry($dropDownElement: JQuery,
                                            $inputElement: JQuery, context: IContext): void {
        const availableMediaWidthPx: number =
            4 + document.body.clientWidth - UitkDropDownGeometryReplicatorForMercury.baseSpacingHorz * 2;
        const minDropDownWidthPx: number =
            4 + Math.min(UitkDropDownGeometryReplicatorForMercury.uitkTypeaheadMinWidthPx, availableMediaWidthPx);
        const maxDropDownWidthPx: number =
            4 + Math.min(UitkDropDownGeometryReplicatorForMercury.uitkTypeaheadWidthPx, availableMediaWidthPx);
        let newWidth: number = Math.min(maxDropDownWidthPx, availableMediaWidthPx);
        let leftOffset: number = $inputElement.offset().left - 2;

        if (leftOffset + newWidth > availableMediaWidthPx) {
            leftOffset = UitkDropDownGeometryReplicatorForMercury.baseSpacingHorz
                + availableMediaWidthPx - newWidth - 2;
            // 2px: The border of the autocomplete-dropdown is 2px narrower than that of the input
        }
        leftOffset = leftOffset - $inputElement.get(0).getBoundingClientRect().left;

        // Logic for nonmobile takeover experience
        if (ExecutionHelper.shouldExecute(context, configuration)) {
            let inputId: string = $inputElement.attr("id");

            /*
            // Calculate the offset for right applicable
            if (UitkDropDownGeometryReplicatorForMercury.rightOffsetApplicableInputs
                    .indexOf(inputId) > -1) {
                leftOffset = -(2 * $inputElement.get(0).getBoundingClientRect().width
                    - $inputElement.get(0).getBoundingClientRect().width + 12);
            }
            */

            // Always left aligned with input
            leftOffset = leftOffset + 2;

            /*
            // Calculate the width for pages with 2 inputs
            if (UitkDropDownGeometryReplicatorForMercury.twoInputsApplicable.indexOf(inputId) > -1) {
                // newWidth = 2 * $inputElement.get(0).getBoundingClientRect().width + 12;
            }
            */

            // Calculated for single input pages only
            if (!(UitkDropDownGeometryReplicatorForMercury.twoInputsApplicable.indexOf(inputId) > -1)) {
                newWidth = $inputElement.get(0).getBoundingClientRect().width;
            }

            UitkDropDownGeometryReplicatorForMercury.applyDropDownGeometry(
                $dropDownElement, leftOffset, newWidth, minDropDownWidthPx, newWidth);

        } else {
            // Default logic for uitk dropdown replicator
            UitkDropDownGeometryReplicatorForMercury.applyDropDownGeometry(
            $dropDownElement, leftOffset, maxDropDownWidthPx, minDropDownWidthPx, newWidth);

        }
    }

    private static applyDropDownGeometry(
        $dropDownElement: JQuery, leftOffset, maxDropDownWidthPx, minDropDownWidthPx, newWidth): void {
        $dropDownElement.css({
            "left": leftOffset + "px",
            "max-width": maxDropDownWidthPx + "px",
            "min-width": minDropDownWidthPx + "px",
            "width": newWidth + "px",
        });
    }

    private showHandlers: {[inputElementId: string]: (event: JQueryEventObject) => any} = {};

    public handleDropDownShow($dropDownElement: JQuery, $inputElement: JQuery, context: IContext): void {
        if (UitkDropDownGeometryReplicatorForMercury.applicableClients.indexOf(context.clientId) >= 0) {
            this.doHandleDropDownShow($dropDownElement, $inputElement, context);
        }
    }

    private doHandleDropDownShow($dropDownElement: JQuery, $inputElement: JQuery, context: IContext): void {
        const optimizeDropDownGeometry = (event: JQueryEventObject): any => {
            UitkDropDownGeometryReplicatorForMercury
                .optimizeDropDownGeometry($dropDownElement, $inputElement, context);
        };
        optimizeDropDownGeometry(null);
        $(window).on(UitkDropDownGeometryReplicatorForMercury.resizeEventTypes, null, null, optimizeDropDownGeometry);
        const inputElementId: string = $inputElement.attr("id");
        if (inputElementId) {
            this.showHandlers[$inputElement.attr("id")] = optimizeDropDownGeometry;
        }
    }
}
